import type { Directive } from 'vue'
import { getPlatform } from '@/plugins/cookie'
import { getAuth } from '@/plugins/cookie'
import router from  '../../router/index'



const auth: Directive = {
  created (el: HTMLElement, binding: any, vnode: any): void {
    let route = router.currentRoute.value
    if(route.path.includes('operate')) {
      let index = binding.value.indexOf(':')
      let char = getPlatform()
      binding.value = binding.value.slice(0, index) + ':' +char + binding.value.slice(index)
    }
    console.log(binding.value)
    let auth = getAuth()
    let isShow: any = auth.includes(binding.value)
    console.log(isShow)
    el.style.visibility = isShow ? 'visible' : 'hidden'
  }
}

export default auth
